// extracted by mini-css-extract-plugin
export default {"controls":"C_nV7hTG08","preview":"wtPlPKLlnA","body":"FmJKcinpIO","column":"kl2vzt4ZV4"};